import {Logger, NumberUtils} from 'neo-common';
import {Balance, GameDataLoaded, IPlatforms, RoundEnded} from './IPlatforms';
import {Platforms} from './Platforms';

export class PlatformEveryMatrix implements IPlatforms {

    private currentBalance: number;
    private currentBet: number;
    private inSpin: boolean;

    public create(): void {
        Platforms.canPlay = true;
        this.currentBalance = -1;
        this.inSpin = false;

        if (DEBUG) {
            this.log('create');
        }

        window.addEventListener('message', this.receiveMessage.bind(this));
    }

    public loadProgress(progress: number): void {
        if (DEBUG) {
            this.log('loadProgress');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'loadProgress', 'sender': 'game', 'data': progress
            }, Platforms.pluginOrigin);
        }
    }

    public gameReady(): void {
        if (DEBUG) {
            this.log('gameReady');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'loadCompleted', 'sender': 'game'
            }, Platforms.pluginOrigin);
        }
    }

    public gameFailed(): void {}

    public gameClosing(): void {
        if (DEBUG) {
            this.log('gameClosing');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'closed', 'sender': 'game'
            }, Platforms.pluginOrigin);
        }
    }

    public gameReloading(): void {}

    public gameChange(gameCode: string): void {}

    public error(code: string, message: string): void {
        if (DEBUG) {
            this.log('error');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'errorMessage', 'sender': 'game', 'data': {'errorCode': code, 'errorMessage': message}
            }, Platforms.pluginOrigin);
        }
    }

    public clientError(id: string, message: string): void {}

    public roundInit(): void {}

    public roundStarted(): void {
        if (DEBUG) {
            this.log('roundStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'roundStart', 'sender': 'game'
            }, Platforms.pluginOrigin);
        }
    }

    public spinStarted(): void {
        this.inSpin = true;
    }

    public spinReceived(): void {}

    public spinEnded(): void {
        this.inSpin = false;
    }

    public roundEnded(): void {
        if (DEBUG) {
            this.log('roundEnded');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'roundEnd', 'sender': 'game'
            }, Platforms.pluginOrigin);
        }
    }

    public featureStarted(): void {}

    public featureInit(): void {}

    public featureFinished(): void {}

    public autoplayStarted(): void {}

    public autoplayFinished(): void {}

    public gotoCasier(): void {}

    public gotoHistory(): void {}

    public gotoHelp(): void {}

    public gotoPaytable(): void {}

    public balanceUpdated(args?: Balance): void {
        if (DEBUG) {
            this.log('balanceUpdated');
        }

        if (Platforms.pluginOrigin != null && args != null) {

            const data = {
                balance: args.amount,
                previousBalance: this.currentBalance,
                totalBet: this.currentBet,
            }

            let win = parseFloat(NumberUtils.subtract(args.amount, this.currentBalance));
            if (win < 0) {
                win = 0;
            }

            if (this.inSpin && win > 0) {
                win = parseFloat(NumberUtils.add(win, this.currentBet));
            }

            if (this.currentBalance === args.amount) {
                return;
            }

            data['totalWin'] = win;

            window.parent.postMessage({
                'name': 'balanceUpdate',
                'sender': 'game',
                data
            }, Platforms.pluginOrigin);

            this.currentBalance = args.amount;
        }
    }

    public sendPluginMessage(message: string): void {}

    public setVolume(level: number): void {
        if (DEBUG) {
            this.log('setVolume');
        }

        let audio = level > 0;

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'audioToggle', 'sender': 'game', 'data': audio
            }, Platforms.pluginOrigin);
        }
    }

    public quickSpinEnabled(enabled: boolean): void {}

    public bet(value: number): void {
        if (DEBUG) {
            this.log('bet');
        }

        this.currentBet = value;

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'stakeUpdate', 'sender': 'game', 'data': value
            }, Platforms.pluginOrigin);
        }
    }

    public win(value: number): void {
        if (DEBUG) {
            this.log('win');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'name': 'winUpdate', 'sender': 'game', 'data': value
            }, Platforms.pluginOrigin);
        }
    }

    public userAction(action: string, data: Object): void {}

    public gameDataLoaded(args: GameDataLoaded): void {
        if (DEBUG) {
            this.log('gameDataLoaded');
        }

        if (args.Bet != null) {
            this.bet(args.Bet);
        }

        if(args.Balance != null) {
            this.currentBalance = args.Balance;
        }

        this.setVolume(1); //game always starts with sound enabled sound
    }

    public dialogOpened(type: string, isOpen: boolean): void {}

    public fullscreen(enabled: boolean): void {}

    private receiveMessage(event: any): void {
        if (DEBUG) {
            this.log('receiveMessage');
        }

        if (event != null && event.data != null) {
            if (event.data.name != null) {
                switch (event.data.name) {
                    case 'updateBalance':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.refreshBalance();
                        }
                        break;
                    case 'setAudio':
                        if (this.checkOrigin(event.origin)) {
                            if (event.data.data) {
                                Platforms.gameAudioEnable();
                            } else {
                                Platforms.gameAudioMute();
                            }
                        }
                        break;
                    case 'showHelp':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.showHelp();
                        }
                        break;
                    case 'togglePaytable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.togglePaytable();
                        }
                        break;
                    case 'modalWindowOpened':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayStop();
                        }
                        break;
                    case 'modalWindowClosed':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayResume();
                        }
                        break;
                    case 'stopAutospins':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.stopAutoplay();
                        }
                        break;
                }
            }
        }
    }

    private checkOrigin(origin: string): boolean {
        if (Platforms.pluginOrigin !== '*' && origin !== Platforms.pluginOrigin) {
            return false;
        }

        return true;
    }

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('EveryMatrix', 'EveryMatrix' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Platforms/PlatformEveryMatrix.ts
 **/